import { Datagrid, List, NumberInput, ReferenceField, Show, SimpleShowLayout, TextField } from "react-admin";



export function ContestWinnerShow(props) {
    return (
        <Show {...props} >
            <SimpleShowLayout >
                <ReferenceField source="contestId" reference="contest" >
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source="childId" reference="child" >
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source="submissionId" reference="contestSubmission" >
                    <TextField source="name" />
                </ReferenceField>
                <NumberInput source="rank" />
            </SimpleShowLayout>
        </Show>
    )
}